module.exports = __webpack_public_path__ + "static/media/39.a1036f6e.jpg";